var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9888 2C9.36914 2 8.05618 3.3215 8.05618 4.95166V5.05344H4.92135H3.91011C3.40747 5.05344 3 5.46355 3 5.96947C3 6.47537 3.40747 6.8855 3.91011 6.8855H4.92135H5.23366L6.06834 19.3756L6.06847 19.3776C6.16102 20.8518 7.37599 22 8.84383 22H15.1562C16.624 22 17.8389 20.8518 17.9315 19.3777L17.9316 19.3756L18.7664 6.8855H19.0787H20.0899C20.5926 6.8855 21 6.47537 21 5.96947C21 5.46355 20.5926 5.05344 20.0899 5.05344H19.0787H15.9438V4.95166C15.9438 3.3215 14.6308 2 13.0112 2H10.9888ZM14.1236 5.05344H9.87641V4.95166C9.87641 4.33331 10.3744 3.83206 10.9888 3.83206H13.0112C13.6256 3.83206 14.1236 4.33331 14.1236 4.95166V5.05344ZM10.5835 10.0015C10.5619 9.49604 10.1374 9.10386 9.63519 9.12552C9.13301 9.14718 8.74336 9.57449 8.76488 10.0799L9.06825 17.2046C9.08977 17.71 9.51432 18.1023 10.0165 18.0806C10.5186 18.0589 10.9084 17.6317 10.8868 17.1262L10.5835 10.0015ZM15.2351 10.0799C15.2567 9.57449 14.867 9.14718 14.3648 9.12552C13.8626 9.10386 13.4381 9.49604 13.4165 10.0015L13.1132 17.1262C13.0916 17.6317 13.4814 18.0589 13.9835 18.0806C14.4857 18.1023 14.9102 17.71 14.9318 17.2046L15.2351 10.0799Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.4765378f.svg";
export { ForwardRef as ReactComponent };